<template>
  <div style="width: 100%">
    <v-alert dismissible v-if="errors" type="error">{{ errorMessage }}</v-alert>
    <v-alert dismissible v-if="success" type="success">{{ successMessage }}</v-alert>
    <v-breadcrumbs item-text="text" :items="breadcrumbs"></v-breadcrumbs>
    <v-card-title> Create Invoice: OPD Invoice </v-card-title>
    <v-row>
      <v-col cols="3">
        <div>
          <template>
            <v-card-title >{{ patient.patient_name }}</v-card-title>

            <v-simple-table dense>
              <template v-slot:default>
                <tbody >
                <tr>
                  <td>Patient ID</td>
                  <td>{{ appointment.patient_id }}</td>
                </tr>

                <tr>
                  <td>DOB</td>
                  <td>{{ patient.patient_dob }}</td>
                </tr>
                <tr>
                  <td>Phone</td>
                  <td>{{ patient.patient_phone }}</td>
                </tr>
                <tr>
                  <td>Family Eye Card</td>
                  <td>{{ patient.family_eye_card }}</td>
                </tr>
                <tr>
                  <td>Occupation</td>
                  <td>{{ patient.patient_occupation}}</td>
                </tr>
                <tr>
                  <td>Bloog Group</td>
                  <td>{{ patient.patient_blood_group }}</td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>{{ patient.patient_email }}</td>
                </tr>
                <tr>
                  <td>Address</td>
                  <td>{{ patient.patient_address }}</td>
                </tr>
                <tr>
                  <td>Registration Date</td>
                  <td>{{ patient.admission_date }}</td>
                </tr>
                <tr>
                  <td>Consultation Doctor</td>
                  <td>{{ doctor.dr_name }}</td>
                </tr>
                <tr>
                  <td>Patient Serial</td>
                  <td>{{ appointment.serial_no }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
        </div>
      </v-col>
      <v-col cols="9">
        <v-row>
          <v-col cols="2"> </v-col>
          <v-col cols="3">
            <v-btn
                depressed
                color="primary"
                :disabled="btnSubmit"
                class="mx-2"
                @click="formSubmitConfirmation"
            >
              Submit
            </v-btn>
            <v-btn depressed color="info" :disabled="printBtn" @click="print_invoice">
              <v-icon>mdi-printer</v-icon>
            </v-btn>
          <v-btn  class="mx-2" depressed color="success" :disabled="printBtnpres" @click="print_prescription">
            <v-icon>mdi-message-text</v-icon>
          </v-btn>
          </v-col>
        </v-row>
        <div class="text-right"></div>

        <div class="invoice-box">
          <table cellpadding="0" cellspacing="0" dense>
            <tr class="heading">
              <td width="35%">Item</td>
              <td width="30%"></td>
              <td width="10%">UC</td>
              <td width="10%">Cost</td>
              <td width></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-right" colspan="2">Total:</td>
              <td class="text-right">{{ this.total | currency }}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-right" colspan="2">Subtotal:</td>
              <td class="text-right">{{ total | currency }}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-right" colspan="2">Discount Amount:</td>
              <td class="text-right">{{ discountTotal | currency }}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-right" colspan="2">Cashback Amount:</td>
              <td class="text-right">{{ submitData.cashback_amount | currency }}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-right" colspan="2">Payable Amount:</td>
              <td class="text-right">{{ payableAmount | currency }}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-right" colspan="2">Due Amount:</td>
              <td class="text-right">
                <v-chip class="error">{{ dueAmount | currency }}</v-chip>
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-right" colspan="2">Discount %:</td>
              <td colspan="2">
                <v-select
                    v-model="submitData.invoice_discount"
                    :items="discountList"
                    label="Discount %"
                    dense
                    outlined
                ></v-select>
              </td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-right" colspan="2">Received :</td>
              <td colspan="2">
                <v-text-field
                    label="Received Amount"
                    v-model="submitData.received_amount"
                    dense
                    outlined
                ></v-text-field>
              </td>
              <td></td>
            </tr>

            <tr>
              <td></td>
              <td class="text-right" colspan="2">Payment Method :</td>
              <td colspan="2">
                <v-select
                    v-model="submitData.payment_method"
                    item-text="name"
                    item-value="id"
                    :items="paymentMethods"
                    label="Payment Method"
                    dense
                    outlined
                ></v-select>
              </td>
              <td></td>
            </tr>
          </table>
        </div>
        <v-row align="center" justify="space-around"> </v-row>
      </v-col>
      <template>
        <v-row justify="center">
          <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
              <v-card-title class="text-h5"> Confirmation? </v-card-title>
              <v-card-text>Are you sure want to continue this process?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="orange darken-1" text @click="dialog = false">
                  Let me check
                </v-btn>
                <v-btn color="green darken-1" text @click="formSubmit()"> Agree </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
    </v-row>
  </div>
</template>

<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      nowDate: new Date().toISOString().substr(0, 10),
      btnSubmit: false,
      items: [],
      routedr:this.doctor_id,
      patient_info: null,
      patient: [],
      doctor: [],
      appointment: [],
      dialog: false,
      paymentMethods: ["Cash", "Bkash", "Card"],
      discountList: [
        0,
        5,
        10,
        15,
        20,
        25,
        30,
        35,
        40,
        45,
        50,
        55,
        60,
        65,
        70,
        75,
        80,
        85,
        90,
        95,
        100,
      ],
      eyeType: ["Left Eye", "Right Eye", "Both Eye"],
      // investigations: [],
      // doctors: [],

      row: null,
      submitData: {
        patient_id: null,
        payment_method: "Cash",
        invoice_discount: 0,
        cashback_amount: 0,
        invoice_type: "consultation",
        received_amount: null,
        appointment_id: null,
        user_id: localStorage.getItem("userId"),
      },
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Invoices",
          disabled: false,
          href: "/invoices",
        },
        {
          text: "Create Invoice",
          disabled: true,
          href: "",
        },
      ],
      familyCardStatus:false,
      radioGroup: 1,
      errors: false,
      errorMessage: [],
      success: false,
      successMessage: [],
      isLoading: false,
      search: null,
      printBtn: true,
      printBtnpres: true,
      invoice_id: null,
      loadInvestigation_id: {},
      apiUrl: atshq.defaults.headers.common.api_URL,
      baseUrl: atshq.defaults.headers.common.base_URL,
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.appointment_id = this.$route.params.id;
    this.getPaymentMethos();
    this.getAppointmentPatient();

  },
  methods: {
    print_prescription() {
      window.open(this.returnUrl + "index.php/printdoc/prescription/" + this.invoice_id + "/0");
    },
    print_invoice() {
      window.open(this.returnUrl + "printdoc/invoice/" + this.invoice_id + "/1");
    },
    getPaymentMethos() {
      atshq
          .get("/payment-methods")
          .then((response) => {
            this.paymentMethods = response.data.data;
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    getAppointmentPatient() {
      atshq
          // .get("/appointments/appointments-data?patient_id="+ this.patient_id +"&doctor_id="+ this.doctor_id +"&appointment_date="+this.date+"&id="+this.serial_no)
          .get("/appointments/get-appointment?appointment_id="+this.appointment_id)
          .then((response) => {
            this.appointment = response.data.appointment;
            this.patient = response.data.appointment.patient
            this.doctor = response.data.appointment.doctor
            this.submitData.patient_id = this.patient.patient_id
            this.submitData.appointment_id = this.appointment.id
            this.familyCardStatus = response.data.familyCardStatus
            console.log(this.familyCardStatus)
            if (this.familyCardStatus) {
              this.submitData.cashback_amount =  100
            }
            if (response.data.exitsInvoice) {
              this.exitsInvoice = response.data.exitsInvoice
              this.printBtn = false;
              this.printBtnpres = false;
              this.invoice_id = this.exitsInvoice.invoice_id;
            }
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    getPatient(patient_id) {
      atshq
          .get("patients/patients/" + patient_id)
          .then((response) => {
            this.loadingstatus = false;
            this.patient_info = response.data.data;
            this.submitData.patient_id = response.data.data.patient_id;
          })
          .catch((e) => {
            // this.errors.push(e);
            this.$noty.error("Oops, something went wrong!");
            this.$noty.error(" " + e);
          });
    },
    formSubmitConfirmation() {
      if (!this.submitData.patient_id) {
        this.$noty.error("Oops, Please Select Patient ID");
        return false;
      }
      this.dialog = true;
    },
    formSubmit() {
      let submitUrl = "invoices/invoice-opd";
      atshq
          .post(submitUrl, {
            invoice: this.submitData,
            sub_total: this.subtotal,
            discount: this.invoice_discount,
            discount_amount: this.discountTotal,
            payable_amount: this.payableAmount,
            due_amount: this.dueAmount,
            hospital_payable: this.hospitalPay,
            doctor_payable:this.drPay,
            consultancy_doctor: this.doctor.dr_name,
            doctor_id: this.doctor.id,
            appointment_id:  this.appointment_id,

          })
          .then((response) => {
            // JSON responses are automatically parsed.
            this.loadingstatus = false;
            this.dialog = false;
            this.invoice_id = response.data.exitsInvoice.invoice_id;
            this.printBtn = false;
            this.printBtnpres = false;
            this.exitsInvoice = this.invoice_id
            this.$noty.success(response.data.message);

            this.success = true;
            this.successMessage = response.data.messages;
          })
          .catch((e) => {
            // this.errors.push(e);
            this.$noty.error(e.response.data.message);
          });
    },

  },
  computed: {
    hospitalPay(){
      return this.payableAmount;
    },
    drPay(){
      return 0;
      // return this.submitData.received_amount - this.hospitalPay;
    },
    subtotal(){
      return this.total;
    },
    total() {
      return 100;
      // return this.items.reduce((acc, item) => acc + item.price * item.quantity, 0);
    },
    discountTotal() {
      return (this.total * this.submitData.invoice_discount) / 100;
      // return this.items.reduce(
      //   (acc, item) => acc + (item.price * item.quantity * this.invoice_discount) / 100,
      //   0
      // );
    },
    payableAmount() {
      var kk = this;
      kk.submitData.received_amount = this.total -  this.discountTotal;
      return this.total - this.discountTotal;
    },
    dueAmount() {
      var kk = this;
      if (this.payableAmount - this.submitData.received_amount < 0) {
        kk.submitData.received_amount = 0;
        this.$noty.error("Oops, Invalid Input!");
        return this.payableAmount;
      }
      return this.payableAmount - this.submitData.received_amount;
    },
  },
  filters: {
    currency(value) {
      var value2 = parseFloat(value)
      return value2.toFixed(2);
    },
  },
};
</script>
<style>
.v-list-item__content {
  padding: 0px;
}
.v-input--selection-controls {
  margin-top: 0px;
}
.item-select-box {
  widows: 100%;
  padding: 0;
}
.invoice-mini-box {
  max-width: 200px;
  padding: 30px;
  border: 1px solid #eee;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  font-size: 16px;
  line-height: 24px;
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
  color: #555;
}

.invoice-box table {
  width: 100%;
  line-height: inherit;
  text-align: left;
}

.invoice-box table td {
  padding: 5px;
  vertical-align: top;
}

.invoice-box table tr td:nth-child(n + 2) {
  text-align: center;
}

.invoice-box table tr.top table td {
  padding-bottom: 20px;
}

.invoice-box table tr.top table td.title {
  font-size: 45px;
  line-height: 45px;
  color: #333;
}

.invoice-box table tr.information table td {
  padding-bottom: 40px;
}

.invoice-box table tr.heading td {
  background: #eee;
  border-bottom: 1px solid #ddd;
  font-weight: bold;
}

.invoice-box table tr.details td {
  padding-bottom: 20px;
}

.invoice-box table tr.item td {
  border-bottom: 1px solid #eee;
}

.invoice-box table tr.item.last td {
  border-bottom: none;
}

.invoice-box table tr.item input {
  padding-left: 5px;
}

.invoice-box table tr.item td:first-child input {
  margin-left: -5px;
  width: 100%;
}

.invoice-box table tr.total td:nth-child(2) {
  border-top: 2px solid #eee;
  font-weight: bold;
}

.invoice-box input[type="number"] {
  width: 60px;
}

@media only screen and (max-width: 600px) {
  .invoice-box table tr.top table td {
    width: 100%;
    display: block;
    text-align: center;
  }

  .invoice-box table tr.information table td {
    width: 100%;
    display: block;
    text-align: center;
  }
}

/** RTL **/
.rtl {
  direction: rtl;
  font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
}

.rtl table {
  text-align: right;
}

.rtl table tr td:nth-child(2) {
  text-align: left;
}
</style>
